// @ts-check

import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { getVideoFromUrl } from 'helpers'

import Button from 'js/components/Button/Button'
import Flexer from 'js/components/Flexer/Flexer'
import FormItem from 'js/components/Form/FormItem'
import Popover from 'js/components/Popover/Popover'
import Spacer from 'js/components/Spacer/Spacer'
import ToolButton from 'js/components/Tiptap/components/ToolButton'
import useInsertVideo from 'js/lib/hooks/useInsertVideo'

import VideoIcon from 'icons/video.svg'

import ToolbarPopoverWrapper from './components/ToolbarPopoverWrapper'

const InsertVideo = ({ editor }) => {
    const { t } = useTranslation()

    const { videoValidationPattern, videoHelper } = useInsertVideo()

    const [instance, setInstance] = useState(null)

    const hide = () => {
        instance.hide()
    }

    const handleOnSubmit = ({ url }, evt) => {
        evt.preventDefault()
        evt.stopPropagation()

        const video = getVideoFromUrl(url)

        if (!video) return

        hide()

        editor
            .chain()
            .insertContent({
                type: 'video',
                attrs: {
                    platform: video.type,
                    guid: video.id,
                },
            })
            .focus()
            .run()
        reset()
    }

    const handleOnError = (error) => {
        console.error(error)
    }

    const defaultValues = {
        url: '',
    }

    const {
        control,
        handleSubmit,
        reset,
        formState: { isValid },
    } = useForm({
        mode: 'onChange',
        defaultValues,
    })

    const disabled = editor?.isActive('table')

    return (
        <Popover
            onCreate={setInstance}
            content={
                <ToolbarPopoverWrapper $maximizeWidth>
                    <form
                        onSubmit={handleSubmit(handleOnSubmit, handleOnError)}
                        noValidate
                    >
                        <Spacer spacing="tiny">
                            <FormItem
                                type="text"
                                control={control}
                                name="url"
                                label={t('form.url')}
                                helper={videoHelper}
                                required
                                rules={{
                                    pattern: {
                                        value: videoValidationPattern,
                                        message: t('error.invalid-video-url'),
                                    },
                                }}
                            />

                            <Flexer>
                                <Button
                                    type="submit"
                                    size="normal"
                                    variant="primary"
                                    disabled={!isValid}
                                >
                                    {t('action.insert')}
                                </Button>
                            </Flexer>
                        </Spacer>
                    </form>
                </ToolbarPopoverWrapper>
            }
            offset={[0, 1]}
        >
            <ToolButton tooltip={t('action.insert-video')} disabled={disabled}>
                <VideoIcon />
            </ToolButton>
        </Popover>
    )
}

export default InsertVideo
